module.exports = __webpack_public_path__ + "static/media/phone-hello.0810f209.png";